module.exports = __webpack_public_path__ + "img/any-num18.ed766e2d.png";